import { request } from "@/api";
import type {
  WalletSummary,
  WalletTransaction,
  WalletData,
} from "@/shared/types";

interface FetchHistoryParams {
  limit?: number;
  offset?: number;
  cryptoCurrency?: string;
}

export const fetchWalletSummary = async () => {
  return request<WalletSummary>("/wallet/summary");
};

export const fetchWalletHistory = async (
  params?: FetchHistoryParams,
  signal?: AbortSignal
) => {
  return request<WalletTransaction[]>("/wallet/history", {
    params,
    signal,
  });
};

export const getCryptoBalanceAddress = async (
  currency?: string,
  signal?: AbortSignal
) => {
  return request<WalletData>("/wallet", {
    method: "POST",
    params: {
      currency,
    },
    signal,
  });
};

interface IWithdrawal {
  walletId: number;
  amount: number;
  publicAddress: string;
  tfaCode: string;
}

export const fetchWithdrawal = async (body: IWithdrawal) => {
  return request<WalletData>("/wallet/withdrawal", {
    method: "POST",
    body,
  });
};

export const fetchCancelTransaction = async (transactionId: number) => {
  return request("/wallet/transaction-cancel", {
    method: "POST",
    body: { transactionId },
  });
};

export const fetchWithdrawalCommissions = async () => {
  return request("/wallet/commissions");
};
